import { z } from 'zod';
export const revenueBrandSchema = z.enum(['Houzy', 'Devis', 'Offerten']);
export const RevenueBrand = revenueBrandSchema.enum;
